/**
 * Convert a number to a human-readable number.
 * 
 * e.g. 123456.789 -> 123,456.8
 */
const formatNumber = function ( value ) {
	let args = {};

	if ( ! Number.isInteger( value ) ) {
		value                      = parseFloat( value );
		args.maximumFractionDigits = 2;
	} else {
		value = parseInt( value );
	}

	return value.toLocaleString( 'en', args );
};

/**
 * Prevent repeated instance of an event by only handling the event every
 * X amount of seconds.
 */
const debounce = ( callback, delay = 500 ) => {
	let timer;

	return ( ...args ) => {
		clearTimeout( timer );

		timer = setTimeout(
			() => {
				callback.apply( this, args );
			},
			delay
		);
	};
};

const isDescendant = ( child, parent ) => {
	let node = child.parentNode;

	while ( node ) {
		if ( node === parent ) {
			return true;
		}

		node = node.parentNode;
	}

	return false;
};

export {
	formatNumber,
	debounce,
	isDescendant,
};
